<template>
    <el-checkbox-group size="mini" v-model="checkboxValue" @change="onChange">
        <template v-if="isString">
            <el-checkbox v-for="item in list" :key="item" :label="item">
                {{ item }}
            </el-checkbox>
        </template>
        <template v-else>
            <el-checkbox v-for="item in list" :key="item.value" :label="item.value">
                {{ item.label }}
            </el-checkbox>
        </template>
    </el-checkbox-group>
</template>

<script>

export default {
    props: {
        value: {
            type: Array,
            default: () => { return [] }
        },
        list: {
            type: Array,
            default: () => { return [] }
        },
    },
    computed: {
        // 列表元素是否字符串
        isString() {
            return this.list.length && typeof (this.list[0]) == 'string' ? true : false;
        }
    },
    watch: {
        value() {
            this.init();
        }
    },
    data() {
        return {
            checkboxValue: []
        }
    },
    methods: {
        init() {
            this.checkboxValue = this.value;
        },
        onChange(res) {
            let arr = res.length ? [res[res.length - 1]] : [];
            this.$emit('input', arr);
            this.$emit('change', arr);
        }
    },
    created() {
        this.init();
    },
}
</script>

<style lang="scss" scoped></style>